import { render, staticRenderFns } from "./LastComments.vue?vue&type=template&id=6ab864cd&"
import script from "./LastComments.vue?vue&type=script&lang=ts&"
export * from "./LastComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports